import { HemsUnit } from '../../../../../projects/client';
import { Unit } from '../../../../shared/common/units';
import { UnitsAdaptee } from '../units.model';

export class HemsUnitsAdaptee implements UnitsAdaptee {
  constructor() {}

  standardizeUnit(unit: Unit | string): string {
    switch (unit) {
      case HemsUnit.KWh:
        return Unit.KilowattHour;
      case HemsUnit.KW:
        return Unit.Kilowatt;
      case HemsUnit.Percentage:
        return Unit.Percent;
      case HemsUnit.Kkg:
        return Unit.Kilogram;
      case HemsUnit.Pc:
        return Unit.PC;
      case HemsUnit.CubicMeter:
        return Unit.CubicMeter;
      case HemsUnit.Celcius:
        return Unit.Celsius;
      default:
        return unit;
    }
  }
}
